import {
    Button,
    ButtonProps
} from "@mantine/core";
import {AiOutlineDownload} from "react-icons/ai";
import {useParams} from "react-router-dom";
import {useApplicationScreenshot} from "../hooks/useApplicationScreenshot.ts";

export const DownloadButton = (props: ButtonProps) => {

    const {id: screenshotId} = useParams();
    const {record} = useApplicationScreenshot(screenshotId);

    const disabled = !record?.screenshotUrl || record?.status !== 'COMPLETED';

    return (
        <Button
            component="a"
            href={record?.screenshotUrl || ''}
            target="_blank"
            download
            leftSection={<AiOutlineDownload/>}
            disabled={disabled}
            variant={'filled'}
            {...props}
        >Download</Button>
    );
};
